import { useEffect, useCallback, forwardRef } from "react"

const ContainerBase = ({
    handleClickOutside, 
    availableToClick, 
    ...rest 
}, ref)  => {

    const handleOutsideClick = useCallback(e => {
        if(!ref.current)
            return

        if(!ref.current.contains(e.target)){
            handleClickOutside()
        }
    }, [handleClickOutside, ref])

    useEffect(() => {
        if(availableToClick) 
            setTimeout(() => {
                document.addEventListener("click", handleOutsideClick, false)
            })
        else
            document.removeEventListener("click", handleOutsideClick, false)

        return () => document.removeEventListener("click", handleOutsideClick, false)
    }, [availableToClick, handleOutsideClick])


    return <div ref={ref} {...rest} />
}

export const ContainerThatCloseOutside = forwardRef(ContainerBase)